import Swiper from "swiper/bundle"

var swiper = new Swiper(".mySwiper", {
    autoplay: {
        delay: 3500,
    },
    loop: true,
});

{
    /* <div class="swiper mySwiper">
        <div class="swiper-wrapper">
            <div class="swiper-slide">
                <figure>
                    <img src="" alt="" />
                </figure>
            </div>
        </div>
    </div> */

    // @import '../../node_modules/swiper/swiper-bundle.min.css';

}